<template lang="">
  <div id="content">
    <div class="global_area">
      <div class="path"><a href="#none">Home</a> &gt; <a href="#none">공지사항 관리</a> &gt; <strong>공지사항 리스트</strong></div>
      <h2 class="h_sub">공지사항 보기 <span class="fs_regular">[보기&amp;수정]</span></h2>
    </div>

    <BoardNoticeEditForm :noticeSeq="noticeSeq"/>
  </div>
</template>

<script>
import BoardNoticeEditForm from '@/components/admin/board/BoardNoticeEditForm.vue';

export default {
  props: {
    noticeSeq: {
      type: String,
      required: true
    }
  },
  components: {
    BoardNoticeEditForm
  }
    
}
</script>
<style lang="">
    
</style>